import { Switch } from 'react-router-dom';
import { useModuleFeatureFlag } from '@/providers/FeatureFlag.provider';
import ProtectedRoute from '../../utils/ProtectedRoute';
import { useLockedFeatures } from '../../providers/LockedFeatures.provider';

import SubAccountListContainer from './SubAccountsList/SubAccountListContainer';
import SubAccountDetailsContainer from './SubAccountsList/Details/SubAccountDetailsContainer';
import TransactionDetails from './SubAccountsList/Details/Transactions/TransactionDetails';
import AccountTransferContainer from './AccountTransfer/AccountTransferContainer';
import SubAccountCreation from './SubAccountsList/SubAccountCreation/SubAccountCreationContainer';
import FundTransferDetails from './TransferFunds/FundTransferDetails';
import { JSX } from 'react';

const Routes = (): JSX.Element => {
  const lockedFeatures = useLockedFeatures();
  const featureFlags = useModuleFeatureFlag('subAccounts');

  return (
    <Switch>
      <ProtectedRoute
        isAllowed={
          !!lockedFeatures.AccountTransferEnabled && featureFlags.isEnabled && featureFlags.CreateAccountTransfer
        }
        showPermission
        exact
        path="/sub-account-transaction/details/:Type/:TransactionID/:Currency"
        component={TransactionDetails}
      />
      <ProtectedRoute
        isAllowed={
          !!lockedFeatures.AccountTransferEnabled && featureFlags.isEnabled && featureFlags.CreateAccountTransfer
        }
        showPermission
        path="/sub-accounts/transfer/fundTransfer/details"
        exact
        component={FundTransferDetails}
      />
      <ProtectedRoute
        isAllowed={
          !!lockedFeatures.AccountTransferEnabled && featureFlags.isEnabled && featureFlags.CreateAccountTransfer
        }
        showPermission
        exact
        path="/sub-account-transfer"
        component={AccountTransferContainer}
      />
      <ProtectedRoute
        isAllowed={!!lockedFeatures.SubAccountPermissions && featureFlags.isEnabled && featureFlags.ViewSubaccounts}
        showPermission
        exact
        path="/create-sub-account"
        component={SubAccountCreation}
      />
      <ProtectedRoute
        isAllowed={!!lockedFeatures.SubAccountPermissions && featureFlags.isEnabled && featureFlags.ViewSubaccounts}
        showPermission
        exact
        path="/sub-accounts-list"
        component={SubAccountListContainer}
      />
      <ProtectedRoute
        isAllowed={!!lockedFeatures.SubAccountPermissions && featureFlags.isEnabled && featureFlags.ViewSubaccounts}
        showPermission
        exact
        path="/sub-accounts-list/details/:AccountID/:Currency"
        component={SubAccountDetailsContainer}
      />
    </Switch>
  );
};

export default Routes;
